import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root'
})

export class AddressService {

  constructor(private api: ApiService) {

  }

  public async searchAddress(text: string, container?: string) {
    return await this.api.searchAddress({ text, container });
  }

  public async getAddress(id: string) {
    return await this.api.getAddress({ id });
  }
}
